// extracted by mini-css-extract-plugin
module.exports = {"container":"Notebook__container--1t8h75Lw3H"};